/**
 * 浏览器设备指纹工具
 * 生成/读取一个持久化的随机唯一标识（存 localStorage），
 * 用于客户浏览分享链接时，后端记录设备唯一标识。
 */
const KEY = 'bjsp_device_id'

function generateId() {
  const uuid = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10)
  return uuid
}

/**
 * 获取设备指纹（不存在则生成并持久化）
 */
export function getDeviceId() {
  let id = localStorage.getItem(KEY)
  if (!id) {
    id = generateId()
    localStorage.setItem(KEY, id)
  }
  return id
}